// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/

.MoreFiltersModal-logInModalContainer-nNJoq {
  max-width: 680px;
  width: 100%;
}

.MoreFiltersModal-logInModalBody-Nchc_ {
  padding: 0px;
}

.MoreFiltersModal-panelHeader-e7xPc {
  font-size: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
  background: transparent;
  text-align: center;
}

@media (max-width:991px) and (min-width:768px) {
  .MoreFiltersModal-logInModalContainer-nNJoq {
    width: auto;
    display: block;
    margin: 30px 15px;
    max-width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .MoreFiltersModal-logInModalContainer-nNJoq {
    display: block;
    width: auto;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MoreFiltersModal/MoreFiltersModal.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;EAC9C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/** RentAll - Begin **/\n\n.logInModalContainer {\n  max-width: 680px;\n  width: 100%;\n}\n\n.logInModalBody {\n  padding: 0px;\n}\n\n.panelHeader {\n  font-size: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n  background: transparent;\n  text-align: center;\n}\n\n@media (max-width:991px) and (min-width:768px) {\n  .logInModalContainer {\n    width: auto;\n    display: block;\n    margin: 30px 15px;\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .logInModalContainer {\n    display: block;\n    width: auto;\n    max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logInModalContainer": `MoreFiltersModal-logInModalContainer-nNJoq`,
	"logInModalBody": `MoreFiltersModal-logInModalBody-Nchc_`,
	"panelHeader": `MoreFiltersModal-panelHeader-e7xPc`
};
module.exports = ___CSS_LOADER_EXPORT___;
